var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-welcome text-center"},[_c('p',[_vm._v("Welcome back, "+_vm._s(_vm.name)+" 👏🏻")])])
}
var staticRenderFns = []

export { render, staticRenderFns }